import { FormType } from '../../../form-types';

export const peBelugaMonthly: FormType = {
  name: 'PE Follow Up Visit',
  questions: [
    'peBelugaFollowup_height',
    'peBelugaFollowup_weight',
    {
      key: 'peBelugaFollowup_healthChanges',
      next: {
        condition: {
          'peBelugaFollowup_healthChanges.peBelugaFollowup_healthChanges_yes':
            true
        },
        key: 'peBelugaFollowup_healthChanges_details',
        els: 'peBelugaFollowup_medicationStatus'
      }
    },
    'peBelugaFollowup_healthChanges_details',
    {
      key: 'peBelugaFollowup_medicationStatus',
      next: {
        condition: {
          'peBelugaFollowup_medicationStatus.peBelugaFollowup_medicationStatus_notWell':
            true
        },
        key: 'peBelugaFollowup_medicationStatus_details',
        els: 'peBelugaFollowup_sideEffects'
      }
    },
    'peBelugaFollowup_medicationStatus_details',
    {
      key: 'peBelugaFollowup_sideEffects',
      next: {
        condition: {
          'peBelugaFollowup_sideEffects.peBelugaFollowup_sideEffects_yes': true
        },
        key: 'peBelugaFollowup_sideEffects_details',
        els: 'peBelugaFollowup_otherInformation'
      }
    },
    'peBelugaFollowup_sideEffects_details',
    'peBelugaFollowup_otherInformation',
    {
      key: 'peBelugaFollowup_truthConsent',
      next: {
        condition: {
          'peBelugaFollowup_truthConsent.peBelugaFollowup_truthConsent_disagree':
            true
        },
        key: 'peBelugaFollowup_ineligible',
        els: 'peBelugaFollowup_treatmentConsent'
      }
    },
    {
      key: 'peBelugaFollowup_treatmentConsent',
      next: {
        condition: {
          'peBelugaFollowup_treatmentConsent.peBelugaFollowup_treatmentConsent_disagree':
            true
        },
        key: 'peBelugaFollowup_ineligible',
        els: 'peBelugaFollowup_complete'
      }
    },
    'peBelugaFollowup_ineligible',
    'peBelugaFollowup_complete'
  ]
};
